import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommIFStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-comms-status-indicator',
    templateUrl: './comms-status-indicator.component.html',
    styleUrls: ['./comms-status-indicator.component.scss'],
    standalone: false,
})
export class CommsStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() selectedComm: CommIFStatus;
    @Output() onGoBack: EventEmitter<void> = new EventEmitter<void>();

    constructor(private systemStatusService: SystemStatusService) {}

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.selectedComm) > 0;
    }

    getIcon(alarmValue: 0 | 1): string {
        if (!this.isReceivingData) return '';
        if (alarmValue === 0) {
            return 'status-error';
        } else if (alarmValue === 1) {
            return 'status-check';
        }
    }
}
